module.exports = __webpack_public_path__ + "img/12.fb799900.png";